

import { defineComponent } from 'vue';

export default defineComponent({
    name: 'BoxBox',
    data () {
        return{
            estilos: {
                background: '#faf0ca',

            }
        }
    }
})

